import { APP_NAME } from "../config";

  
export function getManifestUrl(baseUrl) {
    const url = new URL(baseUrl);
    const token = localStorage.getItem('authorizeToken');
    url.searchParams.append("appName",APP_NAME)  
    if(token){
        url.searchParams.append("token", token);

    }
    return url.toString();
}
  
  